import React from "react";
import "../style/Story.css";
import shampoo100 from "../images/100ml_shampoo.png";

const stats = [
  { id: 1, value: "50k+", label: "Happy customers" },
  { id: 2, value: "100%", label: "Paraben free" },
  { id: 3, value: "4.6★", label: "Average rating" },
];

const Story = () => {
  return (
    <section id="about" className="story">
      <div className="story-inner">
        <div className="story-image-wrap">
          <img
            src={shampoo100}
            alt="Rammyaa Arnica Shampoo 100 ml bottle"
            className="story-image"
          />
        </div>
        <div className="story-content">
          <h2 className="section-title">Our Story</h2>
          <p className="story-paragraph">
            Rammyaa began with a simple belief, that effective haircare
            should never come at the cost of your scalp's health. We
            searched for a formulation that families could use every day,
            and found our answer in Arnica: a botanical long trusted for
            soothing the scalp and supporting stronger roots.
          </p>
          <p className="story-paragraph">
            Every bottle we make is free from parabens, urea and salt, pH
            balanced, and tested for safety before it reaches you. From our
            first Arnica Shampoo to our Rosemary Biotin Hair Vitalizer, our
            promise stays the same: honest ingredients, visible results,
            and care you can feel good about.
          </p>
          <div className="story-stats">
            {stats.map((stat) => (
              <div key={stat.id} className="story-stat">
                <p className="story-stat-value">{stat.value}</p>
                <p className="story-stat-label">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
